import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Courses from "./components/Courses";
import HowItWorks from "./components/HowItWorks";
import WhyUs from "./components/WhyUs";
import Enquiry from "./components/Enquiry";
import Footer from "./components/Footer";
import WhatsAppFab from "./components/WhatsAppFab";
import Faq from "./components/Faq";
import { useHomeSEO } from "./hooks/useCourseSEO";
import BlogList from "./pages/Blog/BlogList";
import BlogDetail from "./pages/Blog/BlogDetail";
import { AuthProvider } from "./admin/AuthContext";
import ProtectedRoute from "./admin/ProtectedRoute";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import ManageCourses from "./admin/ManageCourses";
import CourseForm from "./admin/CourseForm";
import ManageBlogs from "./admin/ManageBlogs";
import BlogForm from "./admin/BlogForm";
import ManageFaqs from "./admin/ManageFaqs";
import FaqForm from "./admin/FaqForm";
import CoursePage from "./pages/courses/CoursePage";
function Home() {
  useHomeSEO();
  return (
    <main>
      <Hero />
      <Marquee />
      <Courses />
      <HowItWorks />
      <WhyUs />
      <Faq />
      <Enquiry />
    </main>
  );
}
function SiteLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <WhatsAppFab />
    </>
  );
}
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
          <Route path="/courses/:slug" element={<SiteLayout><CoursePage /></SiteLayout>} />
          <Route path="/blog" element={<SiteLayout><BlogList /></SiteLayout>} />
          <Route path="/blog/:slug" element={<SiteLayout><BlogDetail /></SiteLayout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="courses" element={<ManageCourses />} />
            <Route path="courses/new" element={<CourseForm />} />
            <Route path="courses/:id/edit" element={<CourseForm />} />
            <Route path="blogs" element={<ManageBlogs />} />
            <Route path="blogs/new" element={<BlogForm />} />
            <Route path="blogs/:id/edit" element={<BlogForm />} />
            <Route path="faqs" element={<ManageFaqs />} />
            <Route path="faqs/new" element={<FaqForm />} />
            <Route path="faqs/:id/edit" element={<FaqForm />} />
          </Route>
          <Route path="*" element={<Navigate to="/#courses" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}